"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAbsoluteUrl = void 0;
const utils_1 = require("../../../utils");
// Returns absolute URL based on the path and without any query parameters
function getAbsoluteUrl(path, origin, localeCode) {
    const prefixedPath = path && !path.startsWith('/') ? `/${path}` : path;
    const finalPath = localeCode ? `/${localeCode}${prefixedPath || ''}` : `${prefixedPath || '/'}`;
    const url = new URL((0, utils_1.getResolvedPath)(finalPath), origin);
    url.search = '';
    return url.toString();
}
exports.getAbsoluteUrl = getAbsoluteUrl;
//# sourceMappingURL=getAbsoluteUrl.js.map